/**
 * A package's description is HTML written in Tebex's editor. It is shown on the store's
 * own page, so it goes through an allow-list first: plain formatting, links and pictures,
 * never a script, a style or a handler.
 */

const ALLOWED = new Set([
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'ul',
  'ol',
  'li',
  'a',
  'h2',
  'h3',
  'h4',
  'blockquote',
  'span',
  'div',
  'img',
  'hr',
  'code',
  'small',
])

/** Elements dropped with everything inside them, not just unwrapped. */
const DROPPED = new Set([
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'form',
  'template',
  'noscript',
])

const SAFE_URL = /^(https?:|mailto:)/i

function clean(node: Element) {
  for (const child of Array.from(node.children)) {
    const tag = child.tagName.toLowerCase()
    if (DROPPED.has(tag)) {
      child.remove()
      continue
    }
    clean(child)
    if (!ALLOWED.has(tag)) {
      child.replaceWith(...Array.from(child.childNodes))
      continue
    }
    for (const attribute of Array.from(child.attributes)) {
      const name = attribute.name.toLowerCase()
      const keep =
        (tag === 'a' && name === 'href' && SAFE_URL.test(attribute.value.trim())) ||
        (tag === 'img' && name === 'src' && /^https:/i.test(attribute.value.trim())) ||
        (tag === 'img' && name === 'alt')
      if (!keep) child.removeAttribute(attribute.name)
    }
    if (tag === 'a') {
      child.setAttribute('target', '_blank')
      child.setAttribute('rel', 'noreferrer noopener')
    }
    if (tag === 'img') child.setAttribute('loading', 'lazy')
  }
}

export function safeHtml(html: string): string {
  const document = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html')
  const root = document.body.firstElementChild
  if (!root) return ''
  clean(root)
  return root.innerHTML
}

/** The description's words alone, for a card's two lines. */
export function excerpt(html: string): string {
  const document = new DOMParser().parseFromString(html, 'text/html')
  // A paragraph or a list item ends a sentence: "città. Priorità", never "città.Priorità".
  for (const block of document.body.querySelectorAll(
    'p, li, div, br, h1, h2, h3, h4, blockquote',
  )) {
    block.after(' ')
  }
  return (document.body.textContent ?? '').replace(/\s+/g, ' ').trim()
}
